import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';
import { NoAuthGuard } from '@app/guard/no-auth.guard';
import { AuthGuard } from '@app/guard/auth.guard';
import { FreetrackComponent } from '@modules/freetrack/freetrack/freetrack.component';
const routes: Routes =
  [
    {
      path: '',
      redirectTo: '/login',
      pathMatch: 'full',
    },
    {
      path: '',
      component: ContentLayoutComponent,
      canActivate: [AuthGuard],
      children: [
        {
          path: 'dashboard',
          loadChildren: () =>
            import('@modules/dashboard/dashboard.module').then(m => m.DashboardModule)
        },
        {
          path: 'centraldashboard',
          loadChildren: () =>
            import('@modules/central-dashboard/central-dashboard.module').then(m => m.CentralDashboardModule)
        },
        {
          path: 'entry',
          loadChildren: () =>
            import('@modules/entry/entry.module').then(m => m.EntryModule)
        },
        {
          path: 'track',
          loadChildren: () =>
            import('@modules/track/track.module').then(m => m.TrackModule)
        },
        {
          path: 'alert',
          loadChildren: () =>
            import('@modules/alerts/alerts.module').then(m => m.AlertsModule)
        },
        {
          path: 'geofence',
          loadChildren: () =>
            import('@modules/geofence/geofence.module').then(m => m.GeofenceModule)
        },
        {
          path: 'map',
          loadChildren: () =>
            import('@modules/map/map.module').then(m => m.MapModule)
        },
        {
          path: 'sidebar',
          loadChildren: () =>
            import('@modules/r-sidebar/r-sidebar.module').then(m => m.RSidebarModule)
        },
        {
          path: 'asset',
          loadChildren: () =>
            import('@modules/asset/asset.module').then(m => m.AssetModule)
        },
        {
          path: 'device_monitoring',
          loadChildren: () =>
            import('@modules/device-monitoring/device-monitoring.module').then(m => m.DeviceMonitoringModule)
        },
        {
          path: 'cash_records',
          loadChildren: () =>
            import('@modules/cash-reports/cash-reports.module').then(m => m.CashReportsModule)
        },
        {
          path: 'logs',
          loadChildren: () =>
            import('@modules/logs/logs.module').then(m => m.LogsModule)
        },
        {
          path: 'summary',
          loadChildren: () =>
            import('@modules/summary/summary.module').then(m => m.SummaryModule)
        },
        {
          path: 'register',
          loadChildren: () =>
            import('@modules/register/register.module').then(m => m.RegisterModule)
        },
        {
          path: 'deviceLogs',
          loadChildren: () =>
            import('@modules/device-logs/device-logs.module').then(m => m.DeviceLogsModule)
        },
        {
          path: 'routes',
          loadChildren: () =>
            import('@modules/route/route.module').then(m => m.RouteModule)
        },
        // {
        //   path: 'video',
        //   loadChildren: () =>
        //     import('@modules/video/video.module').then(m => m.VideoModule)
        // },
        // {
        //   path: 'profile',
        //   loadChildren: () =>
        //     import('@modules/profile/profile.module').then(m => m.ProfileModule)
        // },
        // {
        //   path: 'edit-profile',
        //   loadChildren: () =>
        //     import('@modules/edit-profile/edit-profile.module').then(m => m.EditProfileModule)
        // },
        // {
        //   path: 'attendance',
        //   loadChildren: () =>
        //     import('@modules/attendance/attendance.module').then(m => m.AttendanceModule)
        // },
        // {
        //   path: 'meeting',
        //   loadChildren: () =>
        //     import('@modules/meeting/meeting.module').then(m => m.MeetingModule)
        // },
      ]
    },
    {
      path: 'auth',
      component: AuthLayoutComponent,
      canActivate: [NoAuthGuard],
      loadChildren: () => import('@modules/auth/auth.module').then(m => m.AuthModule)
    },
    {
      path: 'tracking',
      component: FreetrackComponent,
      canActivate: [NoAuthGuard],
      loadChildren: () => import('@modules/freetrack/freetrack.module').then(m => m.FreetrackModule)
    },
    { path: '**', redirectTo: '/login', pathMatch: 'full' }
  ];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
